module.exports = {"title":"Stereonet"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/stereonet/en/messages.json
// module id = 244
// module chunks = 0